/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebDeleteFavoriteByIdsModel,
  IWebDeleteFavoriteByIdsRequest,
  IMappers,
  IWebDeleteFavoriteByIdsResponse,
  IWebDeleteFavoriteByIdsResponseError,
  TWebDeleteFavoriteByIdsResponse,
} from './types';

const defaultConfig: TWebDeleteFavoriteByIdsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/delete-favorite-by-ids/',
  hostType: 'api',
} as TWebDeleteFavoriteByIdsModel;

function createWebDeleteFavoriteByIdsModel(parameters: IWebDeleteFavoriteByIdsRequest): TWebDeleteFavoriteByIdsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebDeleteFavoriteByIdsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebDeleteFavoriteByIdsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebDeleteFavoriteByIds<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebDeleteFavoriteByIdsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebDeleteFavoriteByIdsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebDeleteFavoriteByIdsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebDeleteFavoriteByIdsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebDeleteFavoriteByIdsResponseError);
    }
  }

  return { response, statusCode } as TWebDeleteFavoriteByIdsResponse;
}

export { defaultConfig, createWebDeleteFavoriteByIdsModel, fetchWebDeleteFavoriteByIds };
